import {action, observable} from 'mobx';
import {CatalogEntity} from '../Entity/CatalogEntity';
import {CatalogsRepository} from '../Repository/CatalogsRepository';
import {CatalogPageEntity} from '../Entity/CatalogPageEntity';

export enum CatalogDisplayMode {
  ONE_SITE = 'one-site',
  MAGAZINE = 'magazine'
}

export class CatalogController {
  @observable catalog?: CatalogEntity;
  @observable activePage?: CatalogPageEntity;
  @observable displayMode: CatalogDisplayMode = CatalogDisplayMode.ONE_SITE;

  constructor(private readonly catalogsRepository: CatalogsRepository) {}

  @action async loadCatalog(catalogId: string) {
    this.catalog = await this.catalogsRepository.findOneById(catalogId);
    this.activePage = this.catalog?.firstPage;
  }

  updateActivePage = (pageIndex?: number) => {
    if (!pageIndex && pageIndex !== 0) {
      this.activePage = undefined;
    }

    if (this.catalog) {
      const pages = this.catalog[this.displayMode === CatalogDisplayMode.ONE_SITE ? 'pagesOneSiteMode' : 'pagesMagazineMode'];

      pages.map((page, index) => {
        if (pageIndex === index) {
          this.activePage = page[0];
        }
      });
    }
  }
}
